export default "__VITE_ASSET__CtteEH3r__"